module.exports = __webpack_public_path__ + "static/media/Purchase_order_template.b1debb8d.xlsx";